<template>
  <div>
    <v-dialog ref="dialog" persitent v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>{{ title }} {{ selectedItem.name }}</v-card-title>
        <v-card-text>
          <span style="font-size: 0.8rem">
            <i18n path="confirmDialog.studentHint" tag="span">
              <template #count>
                <strong>{{ selectedItem.frequency }}</strong>
              </template>
              <template #options>{{
                selectedItem.frequency === 1
                  ? $t("confirmDialog.option")
                  : $t("confirmDialog.options")
              }}</template>
            </i18n>
          </span>
          <v-row dense>
            <v-col
              class="d-flex align-center justify-start"
              cols="12"
              v-for="(day, index) in displayDates"
              :key="index"
              style="height: auto; width: auto"
            >
              <v-checkbox
                v-model="selected"
                :label="
                  $t('confirmDialog.studentSlot', {
                    day: displayDay(day.weekDay),
                    from: day.start,
                    to: day.end,
                  })
                "
                :value="day"
                :disabled="
                  selected.length === selectedItem.frequency &&
                  !selected.includes(day)
                "
              >
              </v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="confirm"
            :disabled="selected.length !== selectedItem.frequency"
          >
            {{ $t("common.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { WEEK_DAY_ITEMS } from "@/shared/classPresentation";

export default {
  name: "confirmation-dialog",
  props: {
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    items: {
      type: [Array, null],
    },
    displayDates: {
      type: [Array, null],
    },
    selectedItem: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: false,
      selected: [],
      days: WEEK_DAY_ITEMS,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirmed", this.selected);
      this.dialog = false;
    },
    displayDay(day) {
      return this.days.find((d) => d.value === day).text;
    },
  },
};
</script>

<style lang="css" scoped></style>
